"use client";

// ===========================================
// konakla - Favori özelliği bağlı ilan kartı
// ===========================================
//
// NEDEN VAR (Y-20): `ListingCard` varsayılan olarak kalbi gösteriyor
// (`showFavorite = true`) ama `isFavorite` ve `onFavoriteClick` OPSİYONEL.
// Dört üretim kullanımında bu proplar verilmiyordu:
//   app/listings/(index)/page.tsx:136 ve :214
//   app/listings/[slug]/page.tsx:401 ve :604
// Sonuç: kalp render ediliyor, tıklanınca `onFavoriteClick?.()` sessizce
// hiçbir şey yapmıyor ve favorilenmiş ilanlarda bile kalp HEP BOŞ görünüyordu.
// Yani kullanıcı favoriye eklediğini sanıyor, hiçbir şey olmuyor. Üstelik
// "Favoriler" mobil alt menüde birincil sekme ve header + footer'da linkli.
//
// Bu dört yer SUNUCU bileşeni olduğu için `useFavorites()` hook'unu doğrudan
// çağıramıyorlar. Bu ince istemci sarmalayıcı o sınırı çözüyor.
//
// Desen yeni değil: `components/common/featured-listings.tsx` (ana sayfa
// karuseli) ve `app/favorites/page.tsx` zaten aynı şeyi yapıyor — burada
// yalnızca tek karta indirgenmiş hâli.

import { ListingCard } from "./listing-card";
import { useFavorites } from "@/hooks";
import type { Listing } from "@/types";

interface FavoritableListingCardProps {
  listing: Listing;
  className?: string;
}

/**
 * Favori durumu `use-favorites` deposuna bağlı `ListingCard`.
 *
 * Depo `useSyncExternalStore` üzerine kurulu; aynı sayfadaki tüm kartlar ve
 * `/favorites` sayfası anında senkron kalır (sekmeler arası dahil).
 */
export function FavoritableListingCard({ listing, className }: FavoritableListingCardProps) {
  const { isFavorite, toggleFavorite } = useFavorites();

  return (
    <ListingCard
      listing={listing}
      className={className}
      isFavorite={isFavorite(listing.id)}
      onFavoriteClick={toggleFavorite}
    />
  );
}
